module.exports = __webpack_public_path__ + "files/6b7b66316f3034d3b726849e69bcd058.png";